<div *ngIf="!aktiv.ugyfelId" class="ures">
  <ion-icon name="business-outline"></ion-icon>
  Először válasszon ügyfelet az <b>Ügyfelek</b> fülön.
</div>

<ng-container *ngIf="aktiv.ugyfelId">
  <div class="n-panel">
    <h3 class="n-panel-cim">NAV-ban beküldött bevallások · Ügyfélportál</h3>
    <p class="halvany" style="margin:0 0 10px">
      A cég nevében a NAV-hoz beküldött bevallások (bármilyen úton – ÁNYK, ONYA, gépi), a NAV Ügyfélportáljáról
      visszakérve, PDF-fel. A lekéréshez a cég Ügyfélkapu-fiókja kell (Szervíz → Ügyfélkapu-fiókok); a lekért PDF-ek
      eltárolódnak, megnyitásukhoz később nem kell újra belépni.
    </p>
    <div style="display:flex; gap:10px; align-items:flex-end; flex-wrap:wrap">
      <label>Bevallási időszak – tól<br><input type="date" [(ngModel)]="tol" (change)="lista()"></label>
      <label>ig<br><input type="date" [(ngModel)]="ig" (change)="lista()"></label>
      <ion-button style="--background:var(--naplo)" (click)="lekeres()" [disabled]="fut">
        <ion-icon slot="start" name="cloud-download-outline"></ion-icon>{{ fut ? 'Lekérés folyamatban…' : 'Lekérés a NAV-tól' }}
      </ion-button>
      <ion-button fill="outline" (click)="lekeres(true)" [disabled]="fut" title="A már letöltött PDF-eket is újra letölti">
        PDF-ek újratöltése
      </ion-button>
      <input type="search" placeholder="Szűrés (nyomtatvány, időszak, iktatószám…)" [(ngModel)]="szuro" style="margin-left:auto; min-width:240px">
    </div>
    <p class="halvany" *ngIf="fut && halad" style="margin:8px 0 0">
      <ion-spinner name="dots" style="height:14px; vertical-align:middle"></ion-spinner>
      {{ halad.uzenet }}<ng-container *ngIf="halad.osszes"> ({{ halad.halad }}/{{ halad.osszes }})</ng-container>
      – a lekérés a háttérben fut, a lap elhagyható.
    </p>
  </div>

  <div class="ures" *ngIf="!betolt && !sorok.length">
    <ion-icon name="document-text-outline"></ion-icon>
    Erre az időszakra még nincs lekért bevallás – a <b>Lekérés a NAV-tól</b> gombbal kérheted le.
  </div>

  <div class="tabla-wrap" *ngIf="sorok.length">
    <table class="naplo-tabla">
      <thead><tr><th>Nyomtatvány</th><th>Bevallási időszak</th><th>Beküldve</th><th>Funkció</th><th>Állapot</th><th>Iktatószám</th><th></th></tr></thead>
      <tbody>
        <tr *ngFor="let s of szurtSorok">
          <td><b>{{ s.kod }}</b><span class="halvany" style="margin-left:8px" [title]="s.nev">{{ s.nev?.length > 70 ? (s.nev | slice:0:70) + '…' : s.nev }}</span></td>
          <td>{{ s.idoszak || '—' }}</td>
          <td>{{ s.benyujtva || '—' }}</td>
          <td>{{ funkcio(s.funkcio) }}</td>
          <td [class.halvany]="s.allapot === 'Törölt'">{{ s.allapot || '—' }}</td>
          <td class="halvany">{{ s.iktato_szam }}</td>
          <td>
            <ion-button size="small" fill="clear" (click)="pdf(s)" [disabled]="!s.van_pdf" [title]="s.van_pdf ? 'A bevallás PDF-je új lapon' : 'Nincs letöltött PDF – kérd le újra'">
              <ion-icon slot="start" name="document-text-outline"></ion-icon>PDF
            </ion-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</ng-container>
